import React, { useState, useContext } from 'react';
import VendorLoginModal from './VendorLoginModal';
import DrivingSchoolAuthModal from './DrivingSchoolAuthModal';
import AgentAuthModal from './AgentAuthModal';
import { AuthContext, useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
    const [showVendorModal, setShowVendorModal] = useState(false);
    const [isVendorRegisterView, setIsVendorRegisterView] = useState(false);
    const [showDrivingSchoolModal, setShowDrivingSchoolModal] = useState(false);
    const [isRegisterView, setIsRegisterView] = useState(false);
    const [showAgentModal, setShowAgentModal] = useState(false);
    const [isAgentRegisterView, setIsAgentRegisterView] = useState(false);

    const { logoutUser } = useContext(AuthContext);
    const { viewMode } = useAuth();
    const navigate = useNavigate();

    const handleVendorClick = (e, register = false) => {
        e.preventDefault();
        if (viewMode === 'vendor') {
            navigate('/vendor/dashboard');
        } else {
            setIsVendorRegisterView(register);
            setShowVendorModal(true);
        }
    };

    const handleDrivingSchoolClick = (e, register = false) => {
        e.preventDefault();
        if (viewMode === 'school') {
            navigate('/school/dashboard');
        } else {
            setIsRegisterView(register);
            setShowDrivingSchoolModal(true);
        }
    };

    const handleLogout = (e) => {
        e.preventDefault();
        logoutUser();
        navigate('/');
    };

    const handleAgentClick = (e, register = false) => {
        e.preventDefault();
        if (viewMode === 'agent') {
            navigate('/agent/dashboard');
        } else {
            setIsAgentRegisterView(register);
            setShowAgentModal(true);
        }
    };

    return (
        <>
            <section className="footer-style-two">
                <div className="footer-top">
                    <div className="auto-container">
                        <div className="row clearfix">

                            {/* About */}
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget logo-widget">
                                    <h1 className="text-white">ASYSTA</h1>
                                    <p>
                                        We provide a complete driving ecosystem including courses,
                                        instructors, vendors and driving schools on a single platform.
                                    </p>
                                    <div className="rating-box">
                                        <h4>Excellent</h4>
                                        <ul className="rating clearfix">
                                            {[...Array(4)].map((_, i) => (
                                                <li key={i}><i className="flaticon-star"></i></li>
                                            ))}
                                            <li><i className="flaticon-star-half-empty"></i></li>
                                        </ul>
                                        <p>Trust Score 4.5 (2,500+ Reviews)</p>
                                    </div>
                                </div>
                            </div>

                            {/* Useful Links */}
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget links-widget text-white">
                                    <h4>Useful Links</h4>
                                    <ul className="links-list clearfix">
                                        <li><a href="#">About Us</a></li>
                                        <li><a href="#">Courses</a></li>
                                        <li><a href="#">Services</a></li>
                                        <li><a href="#">Products</a></li>
                                        <li><a href="#">Mock Test</a></li>
                                        <li><a href="#">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget links-widget text-white">
                                    <h4>Quick Access</h4>
                                    <ul className="links-list clearfix">
                                    
                                        <li><a href="#">How Its Works</a></li>
                                        <li><a href="#">Rules & Signs</a></li>
                                        <li><a href="#">Safety Guide</a></li>

                                        <li>
                                            {viewMode === 'vendor' ? (
                                                <>
                                                    <a href="#" onClick={() => navigate('/vendor/dashboard')}>
                                                        Vendor Dashboard
                                                    </a>
                                                    <span
                                                        onClick={handleLogout}
                                                        style={{ marginLeft: 10, color: '#ff6b6b', cursor: 'pointer' }}
                                                    >
                                                        (Logout)
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <a href="#" onClick={(e) => handleVendorClick(e, false)}>
                                                        Vendor Login
                                                    </a>
                                                    <span className="mx-2 text-white-50">|</span>
                                                    <a href="#" onClick={(e) => handleVendorClick(e, true)}>
                                                        Vendor Register
                                                    </a>
                                                </>
                                            )}
                                        </li>

                                        <li>
                                            {viewMode === 'school' ? (
                                                <>
                                                    <a href="#" onClick={() => navigate('/school/dashboard')}>
                                                        School Dashboard
                                                    </a>
                                                    <span
                                                        onClick={handleLogout}
                                                        style={{ marginLeft: 10, color: '#ff6b6b', cursor: 'pointer' }}
                                                    >
                                                        (Logout)
                                                    </span>
                                                </>
                                            ) : (
                                                <a href="#" onClick={(e) => handleDrivingSchoolClick(e, true)}>
                                                    Register Driving School
                                                </a>
                                            )}
                                        </li>

                                        <li>
                                            {viewMode === 'agent' ? (
                                                <>
                                                    <a href="#" onClick={() => navigate('/agent/dashboard')}>
                                                        Agent Dashboard
                                                    </a>
                                                    <span
                                                        onClick={handleLogout}
                                                        style={{ marginLeft: 10, color: '#ff6b6b', cursor: 'pointer' }}
                                                    >
                                                        (Logout)
                                                    </span>
                                                </>
                                            ) : (
                                                <a href="#" onClick={(e) => handleAgentClick(e, false)}>
                                                    Agent Login / Register
                                                </a>
                                            )}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="auto-container">
                        <div className="bottom-inner clearfix">
                            <p className="pull-left">
                                © 2025 <strong>Asysta</strong>. All Rights Reserved.
                            </p>
                            <ul className="footer-nav pull-right">
                                <li><a href="#">Privacy Policy</a></li>
                                <li><a href="#">Terms of Use</a></li>
                                <li><a href="#">Support</a></li>
                              
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modals */}
            <VendorLoginModal
                show={showVendorModal}
                onClose={() => {
                    setShowVendorModal(false);
                    setIsVendorRegisterView(false);
                }}
                isRegister={isVendorRegisterView}
            />

            <DrivingSchoolAuthModal
                show={showDrivingSchoolModal}
                onClose={() => setShowDrivingSchoolModal(false)}
                isRegister={false}
            />

            <AgentAuthModal
                show={showAgentModal}
                onClose={() => setShowAgentModal(false)}
                isRegister={isAgentRegisterView}
            />
        </>
    );
}
